import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

export interface CommitteeFormValues {
  kind: string;
  name_zh_hk: string;
  name_zh_cn: string;
  name_en: string;
  code: string;
  sort_order: string;
}

export const blankCommittee: CommitteeFormValues = {
  kind: 'functional',
  name_zh_hk: '',
  name_zh_cn: '',
  name_en: '',
  code: '',
  sort_order: '100',
};

const input: CSSProperties = {
  width: '100%',
  borderRadius: 8,
  padding: '6px 10px',
  border: '1px solid var(--color-divider)',
  background: 'var(--color-bg)',
  color: 'var(--color-text)',
  fontSize: 'var(--font-size-small)',
};
const btn: CSSProperties = { padding: '4px 10px', borderRadius: 8, border: '1px solid var(--color-divider)', background: 'var(--color-card)', fontSize: 'var(--font-size-tiny)', cursor: 'pointer' };
const btnPrimary: CSSProperties = { ...btn, background: 'var(--color-primary)', color: 'var(--color-on-primary)' };

/** 委員會新增／編輯表單（由 `/admin/committees` 抽出，守住 ≤200 行） */
export default function CommitteeForm({
  form,
  setForm,
  err,
  kindName,
  onSave,
  onCancel,
}: {
  form: CommitteeFormValues;
  setForm: (f: CommitteeFormValues) => void;
  err: string;
  kindName: (kind: string) => string;
  onSave: () => void;
  onCancel: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="rounded-xl p-4 mb-4" style={{ background: 'var(--color-card)', boxShadow: 'var(--shadow-card)' }}>
      <div className="grid gap-2" style={{ gridTemplateColumns: '1fr 1fr' }}>
        <label className="text-sm">
          {t('committee_kind')}
          <select style={input} value={form.kind} onChange={(e) => setForm({ ...form, kind: e.target.value })}>
            {['board', 'functional', 'working'].map((k) => (
              <option key={k} value={k}>
                {kindName(k)}
              </option>
            ))}
          </select>
        </label>
        <label className="text-sm">
          {t('committee_code')}
          <input style={input} value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} />
        </label>
        <label className="text-sm">
          {t('committee_name_hk')}
          <input style={input} value={form.name_zh_hk} onChange={(e) => setForm({ ...form, name_zh_hk: e.target.value })} />
        </label>
        <label className="text-sm">
          {t('committee_name_cn')}
          <input style={input} value={form.name_zh_cn} onChange={(e) => setForm({ ...form, name_zh_cn: e.target.value })} />
        </label>
        <label className="text-sm">
          {t('committee_name_en')}
          <input style={input} value={form.name_en} onChange={(e) => setForm({ ...form, name_en: e.target.value })} />
        </label>
        <label className="text-sm">
          {t('committee_sort')}
          <input style={input} value={form.sort_order} onChange={(e) => setForm({ ...form, sort_order: e.target.value })} />
        </label>
      </div>
      {err && (
        <p className="text-sm mt-2" style={{ color: 'var(--color-danger)' }}>
          {err}
        </p>
      )}
      <div className="flex gap-2 mt-3">
        <button type="button" style={btnPrimary} onClick={onSave}>
          {t('btn_save')}
        </button>
        <button type="button" style={btn} onClick={onCancel}>
          {t('btn_cancel')}
        </button>
      </div>
    </div>
  );
}
